import React from 'react';

export const Favicons = () => (
  <>
    <link
      href="/shared/favicons/favicon-32x32.svg"
      rel="shortcut icon"
      sizes="32x32"
      type="image/svg+xml"
    />
    <link
      href="/shared/favicons/favicon.ico"
      rel="shortcut icon"
      sizes="16x16"
      type="image/x-icon"
    />

    <link
      href="/shared/favicons/favicon.ico"
      rel="icon"
      sizes="16x16"
      type="image/x-icon"
    />

    <link
      href="/shared/favicons/favicon-16x16.svg"
      rel="icon"
      sizes="16x16"
      type="image/svg+xml"
    />
    <link
      href="/shared/favicons/favicon-32x32.svg"
      rel="icon"
      sizes="32x32"
      type="image/svg+xml"
    />
    <link
      href="/shared/favicons/favicon-48x48.svg"
      rel="icon"
      sizes="48x48"
      type="image/svg+xml"
    />

    <link
      href="/shared/favicons/favicon-96x96.png"
      rel="icon"
      sizes="96x96"
      type="image/png"
    />
    <link
      href="/shared/favicons/favicon-120x120.png"
      rel="icon"
      sizes="120x120"
      type="image/png"
    />
    <link
      href="/shared/favicons/favicon-144x144.png"
      rel="icon"
      sizes="144x144"
      type="image/png"
    />

    <link
      href="/shared/favicons/android-icon-192x192.png"
      rel="icon"
      sizes="192x192"
      type="image/png"
    />

    <link
      href="/shared/favicons/apple-touch-icon-57x57.png"
      rel="apple-touch-icon"
      sizes="57x57"
      type="image/png"
    />
    <link
      href="/shared/favicons/apple-touch-icon-60x60.png"
      rel="apple-touch-icon"
      sizes="60x60"
      type="image/png"
    />
    <link
      href="/shared/favicons/apple-touch-icon-72x72.png"
      rel="apple-touch-icon"
      sizes="72x72"
      type="image/png"
    />
    <link
      href="/shared/favicons/apple-touch-icon-76x76.png"
      rel="apple-touch-icon"
      sizes="76x76"
      type="image/png"
    />
    <link
      href="/shared/favicons/apple-touch-icon-114x114.png"
      rel="apple-touch-icon"
      sizes="114x114"
      type="image/png"
    />
    <link
      href="/shared/favicons/apple-touch-icon-120x120.png"
      rel="apple-touch-icon"
      sizes="120x120"
      type="image/png"
    />
    <link
      href="/shared/favicons/apple-touch-icon-144x144.png"
      rel="apple-touch-icon"
      sizes="144x144"
      type="image/png"
    />
    <link
      href="/shared/favicons/apple-touch-icon-152x152.png"
      rel="apple-touch-icon"
      sizes="152x152"
      type="image/png"
    />
    <link
      href="/shared/favicons/apple-touch-icon-180x180.png"
      rel="apple-touch-icon"
      sizes="180x180"
      type="image/png"
    />

    <link href="/shared/favicons/manifest.json" rel="manifest" />
  </>
);
